/**
 * @generated SignedSource<<8ce2c3c3b2c98c38b759d1f981369bf3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type tagsQuery$variables = {
  categories?: ReadonlyArray<string> | null | undefined;
  organizations?: ReadonlyArray<string> | null | undefined;
  q?: string | null | undefined;
  tags?: ReadonlyArray<string> | null | undefined;
  topics?: ReadonlyArray<string> | null | undefined;
};
export type tagsQuery$data = {
  readonly tags: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly displayName: string;
        readonly name: string;
      };
    }>;
  };
};
export type tagsQuery = {
  response: tagsQuery$data;
  variables: tagsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "categories"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "organizations"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "q"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "tags"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "topics"
},
v5 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "categories",
            "variableName": "categories"
          },
          {
            "kind": "Variable",
            "name": "organizations",
            "variableName": "organizations"
          },
          {
            "kind": "Variable",
            "name": "q",
            "variableName": "q"
          },
          {
            "kind": "Variable",
            "name": "tags",
            "variableName": "tags"
          },
          {
            "kind": "Variable",
            "name": "topics",
            "variableName": "topics"
          }
        ],
        "kind": "ObjectValue",
        "name": "filter"
      }
    ],
    "concreteType": "TagConnection",
    "kind": "LinkedField",
    "name": "tags",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "TagEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Tag",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "displayName",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "tagsQuery",
    "selections": (v5/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "tagsQuery",
    "selections": (v5/*: any*/)
  },
  "params": {
    "cacheID": "839019f6031766af620c4bde2b096a27",
    "id": null,
    "metadata": {},
    "name": "tagsQuery",
    "operationKind": "query",
    "text": "query tagsQuery(\n  $q: String\n  $tags: [String!]\n  $categories: [String!]\n  $organizations: [String!]\n  $topics: [String!]\n) {\n  tags(filter: {q: $q, topics: $topics, tags: $tags, organizations: $organizations, categories: $categories}) {\n    edges {\n      node {\n        name\n        displayName\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d2f2eeb37d6bfee59b37fb6e47277036";

export default node;
